import { render, staticRenderFns } from "./ValidateIQ.vue?vue&type=template&id=0a581ac0&scoped=true"
import script from "./ValidateIQ.vue?vue&type=script&lang=js"
export * from "./ValidateIQ.vue?vue&type=script&lang=js"
import style0 from "./ValidateIQ.vue?vue&type=style&index=0&id=0a581ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a581ac0",
  null
  
)

export default component.exports